module.exports = __webpack_public_path__ + "static/Apercu-LightItalic-b6fb7272d08e5494e74e10f7419573ca.ttf";